export const SET_ENTRY_COMPONENT = 'SET_ENTRY_COMPONENT'
export const RESET_ENTRY_COMPONENT = 'RESET_ENTRY_COMPONENT'

export const setEntryInformation = (entryInfo) => ({
  type: SET_ENTRY_COMPONENT,
  payload: entryInfo,
})

export const resetEntryInformation = () => ({
  type: RESET_ENTRY_COMPONENT,
})
